import { CircularProgress, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const name = "GoHome";

const GoHome: React.FC<{ parent: string }> = ({ parent }) => {
	const navigate = useNavigate();

	React.useEffect(() => {
		setTimeout(() => {
			navigate("/", { replace: true, state: {} });
		}, 300);
	}, [navigate]);

	return (
		<Stack
			sx={{
				position: "absolute",
				top: "50%",
				left: "50%",
				transform: "translate(-50%, -50%)",
			}}
			direction="row"
		>
			<Typography variant="h1">Loading Home...</Typography>
			<CircularProgress color="inherit" variant="indeterminate" size={100} />
		</Stack>
	);
};

GoHome.displayName = name;

export default React.memo(GoHome);
